import React from 'react';
import { Controller } from 'react-hook-form';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import { When } from 'UI/components/atoms';

import {
  ChecksContainer,
  DividerStyled,
  LinkRow,
  LinkRowIcon,
  StyledCard,
  StyledContent,
  TitleIcon,
  TitleRow,
  TruncatedLink
} from './ReminderCard.styled';

const COPIES = strings.sendoutsV2.form.sections.emailReminders;

export const ReminderCard = ({
  candidateFieldName,
  candidateName = '',
  control,
  hiringAuthorityFieldName,
  hiringAuthorityName = '',
  title = '',
  url = null
}) => {
  return (
    <StyledCard>
      <StyledContent>
        <TitleRow>
          <TitleIcon />
          <Typography variant="subtitle1">{title}</Typography>
        </TitleRow>

        <FormGroup>
          <ChecksContainer container spacing={1}>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Controller
                    as={<Checkbox color="primary" />}
                    control={control}
                    defaultValue={false}
                    name={candidateFieldName}
                  />
                }
                label={strings.formatString(COPIES.labels.to, { name: candidateName })}
              />
            </Grid>

            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Controller
                    as={<Checkbox color="primary" />}
                    control={control}
                    defaultValue={false}
                    name={hiringAuthorityFieldName}
                  />
                }
                label={strings.formatString(COPIES.labels.to, { name: hiringAuthorityName })}
              />
            </Grid>
          </ChecksContainer>
        </FormGroup>

        <When condition={url}>
          <DividerStyled />

          <LinkRow>
            <LinkRowIcon fontSize="small" />
            <TruncatedLink href={url} target="_blank" rel="noopener noreferrer" variant="body2">
              {url}
            </TruncatedLink>
          </LinkRow>
        </When>
      </StyledContent>
    </StyledCard>
  );
};
